import { Modal } from '@maskott/tactileo.designsystem';
import { error, neutralLight } from 'assets/colors';
import { RoundedCornerButton } from 'components/atoms';
import styled from 'styled-components';

export const SmallAlertStyled = styled.span`
  font-size: 12px;
  line-height: 15px;
  color: ${error};
`;

export const LabelStyled = styled.label`
  color: black;
`;

export const SmallTextStyled = styled.p`
  font-size: 12px;
  line-height: 15px;
  color: black;
  margin: 0;
`;

export const ConfirmButtonStyled = styled(RoundedCornerButton)`
  margin-top: 24px;
  align-self: center;
`;

export const NewPasswordFieldsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  @media only screen and (max-width: 767px) {
    input {
      border: 1px solid rgb(${(props) => props.theme.colors.primary});
      box-shadow: 0px 1px 0px rgb(${(props) => props.theme.colors.primary});
    }
    input:focus {
      border: 2px solid rgb(${(props) => props.theme.colors.primary});
      background-color: ${neutralLight};
    }
    .errorState {
      border: 2px solid ${error}!important;
      box-shadow: 0px 1px 0px ${error};
      background-color: #fce8e8 !important;
    }
  }
`;

export const ModalTextStyled = styled.h3`
  margin: 0;
  width: 100%;
  font-weight: 900;
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  letter-spacing: 0.35px;
  color: black;
`;

export const ModalStyled = styled(Modal)`
  button {
    border-radius: 2.5rem;
  }
`;

export const CheckImageStyled = styled.img`
  width: 48px;
  height: 48px;
  margin-bottom: 32px;
`;

export const ModalContentStyled = styled.div`
  padding: 143px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
